import type { Post } from "@/shared/lib/types"
import { cn } from "@/shared/lib/utils"
import { HapticLink } from "@/shared/ui/haptic-link"

interface PostTaxonomyLinksProps {
	post: Post
	className?: string
}

export function PostTaxonomyLinks({ post, className }: PostTaxonomyLinksProps) {
	const links = [
		...post.formats.map((item) => ({ id: item.id, name: item.name, to: `/f/${item.id}` })),
		...post.niches.map((item) => ({ id: item.id, name: item.name, to: `/n/${item.id}` })),
		...post.topics.map((item) => ({ id: item.id, name: item.name, to: `/t/${item.id}` })),
	]

	if (links.length === 0) return null

	return (
		<div className={cn("flex flex-wrap gap-2", className)}>
			{links.map((item) => (
				<HapticLink
					key={item.to}
					to={item.to}
					className="rounded-full bg-white/[0.06] px-3 py-1.5 text-xs font-medium ring-1 ring-white/10 transition-transform duration-150 ease-[var(--ease-out-soft)] active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
				>
					{item.name}
				</HapticLink>
			))}
		</div>
	)
}
